import { Component, Input } from '@angular/core';

@Component({
    selector: 'scaffold-layout',
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss',
    standalone: false
})
export class LayoutComponent {
  @Input() showFrame: boolean = false;
  @Input() leftSidebarState: string = 'collapsed';
  @Input() rightSidebarState: string = 'collapsed';
}
